export default {
  businessSignup: 'business/signup',
  businessCoinSetupReserve: 'admin/business_coin_setup/reserve',
  businessCoinSetupValidate: 'admin/business_coin_setup/validate_coin_name',
  businessCoinSetupUpload: 'storage/upload/coin',
  testAB: 'test_ab'
};
